import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectIntake from './pages/ProjectIntake';
import ElectricalForm from './pages/ElectricalForm';
import PhotoManager from './pages/PhotoManager';
import ReportGenerator from './pages/ReportGenerator';
import Settings from './pages/Settings';
import StructuralPhotoManager from './pages/StructuralPhotoManager';
import StructuralDetails from './pages/StructuralDetails';
import StructuralReportGenerator from './pages/StructuralReportGenerator';
import NotFound from './pages/NotFound';
import EditProject from './pages/EditProject';
import Deficiencies from './pages/Deficiencies';
import PrivateRoute from './components/PrivateRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/"                                    element={<LandingPage />} />
          <Route path="/login"                               element={<Login />} />
          <Route path="/privacy"                             element={<PrivacyPolicy />} />
          <Route path="/dashboard"                           element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/projects"                            element={<PrivateRoute><Projects /></PrivateRoute>} />
          <Route path="/project/new"                         element={<PrivateRoute><ProjectIntake /></PrivateRoute>} />
          <Route path="/project/:projectId/electrical"       element={<PrivateRoute><ElectricalForm /></PrivateRoute>} />
          <Route path="/project/:projectId/photos"           element={<PrivateRoute><PhotoManager /></PrivateRoute>} />
          <Route path="/project/:projectId/report"           element={<PrivateRoute><ReportGenerator /></PrivateRoute>} />
          <Route path="/project/:projectId/edit"             element={<PrivateRoute><EditProject /></PrivateRoute>} />
          <Route path="/project/:projectId/structural/photos"     element={<PrivateRoute><StructuralPhotoManager /></PrivateRoute>} />
          <Route path="/project/:projectId/structural/details"    element={<PrivateRoute><StructuralDetails /></PrivateRoute>} />
          <Route path="/project/:projectId/structural/report"     element={<PrivateRoute><StructuralReportGenerator /></PrivateRoute>} />
          <Route path="/project/:projectId/deficiencies"     element={<PrivateRoute><Deficiencies /></PrivateRoute>} />
          <Route path="/settings"                            element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="*"                                    element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;